function S4 () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

/* 生成uuid */
export function getUuid () {
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}



// WEBPACK FOOTER //
// ./src/util/algorithmUtil.js